import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, tap } from "rxjs";
import { environment } from "../environments/environment";

@Injectable({
    providedIn: 'root',
})
export class ClientConfigService {
    private readonly apiUrl = `${environment.apiUrl}`;
    private configSubject = new BehaviorSubject<ClientConfig | null>(null);
    config$ = this.configSubject.asObservable();

    constructor(private http: HttpClient) {
        this.loadConfig().subscribe();
    }

    getCurrentConfig(): ClientConfig | null {
        return this.configSubject.getValue();
    }

    private loadConfig() {
        return this.http.get<ClientConfig>(`${this.apiUrl}/ClientConfig`).pipe(
            tap(config => {
                this.configSubject.next(config);
            })
        );
    }
}

export interface ClientConfig {
    cardKnoxCdnUrl: string;
    cardKnoxGooglePayUrl: string;
    cardKnoxPublicKey: string;
    cardKnoxIsSandbox: boolean;
    audioStorageUrl: string;
    audioGeneratorMaxAttemptsWithoutDelay: number;
    audioGeneratorDelayInMs: number;
    enabledOAuthProviders: string[];
    useVideoFormSessionStorage: boolean;
}
